import React, { FC } from "react";
import { useSelector } from "react-redux";
import TableTabTwo from "../components/tabs/table-tab";
import { DEF_PG_SIZE_LIST_WO_ADD } from '../constants/maximum-page-size';
import { ACCOUNTS } from "../constants/menu-types";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import { TranslationKeys } from "../contexts/TranslationKeys";
import columns from '../models/ColumnDefinitions/MobileAccountColumns';
import { Lookup } from "../models/Lookup";
import LookupTypes from "../models/LookupTypes";
import searchColumns from '../models/search/MobileAccountSearch';
import SiteSearch from "../models/search/SiteSearch";
import { getActiveInactiveTableLegendItems } from "../models/TableLegend";
import { getMobileAccounts } from "../services/mobileAccountService";
import { getSiteNamesWithPagination } from "../services/siteService";

const AccountsTab: FC = () => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.accounts);
    const itemPath = '/access-control/configuration/account/';
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const lookup: Lookup[] = [
        {
            name: LookupTypes.site,
            values: [],
            dataMethod: getSiteNamesWithPagination,
            searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
        }
    ];

    const currentMenuDetail = ACCOUNTS;
    const initialiseUserPreferences = (setDetails: (userLoginId, currentMenuDetail) => void) => {
        setDetails(userLoginId, currentMenuDetail);
    }

    return <TableContextProvider
        dataMethod={getMobileAccounts}
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        tableDescriptor={columns}
        searchDescriptor={searchColumns}
        legendItems={getActiveInactiveTableLegendItems(translate)}
        useTable
        usePagination
        useLegend
        useFilter
        useSearch
        useSort
        maxPageSize={DEF_PG_SIZE_LIST_WO_ADD}
        lookup={lookup}>
        <TableTabTwo
            hideAddNewButton={true}
            title={title}
            selectRows={false}
            rowPath={itemPath}
            cyName="accounts"/>
    </TableContextProvider>;
};

export default AccountsTab;
